<template>
    <div class="genplan-section" v-if="genplanArr != null" id="menu-link-genplan">
        <div class="container">
            <sectionTitle :options="[{ title : genplanArr.genplan_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: genplanArr.genplan_quote_img, title : genplanArr.genplan_quote_title, desc: genplanArr.genplan_quote_desc}]"></sectionBaner>
        </div>
        <div class="genplan-content-container">
            <div class="container">
                <sectionDescColumn :options="[{ desc_left : genplanArr.genplan_left_desc, desc_right: genplanArr.genplan_right_desc}]"></sectionDescColumn>
                <!-- <div class="section-navigation">
                    <ul>
                        <li :class="{'active' : genplanScheme_init}"><a href="#" @click.prevent="switchTab(true)">{{ genplanArr.genplan_nav_first }}</a></li>
                        <li :class="{'active' : !genplanScheme_init}"><a href="#" @click.prevent="switchTab(false)">{{ genplanArr.genplan_nav_second }}</a></li>
                    </ul>
                </div> -->

                <!-- обёртка с анимируемой высотой -->
                <div class="genplan-tabs-wrapper" ref="wrapper">
                    <div class="genplan-tab genplan-apts" :class="{ 'is-active': genplanScheme_init, 'is-leaving': !genplanScheme_init && wasFirst }">
                        <img :src="genplanArr.genplan_default_img" alt="" v-if="globalLang == ''">
                        <img :src="genplanArr.genplan_default_img_kz" alt="" v-if="globalLang == 'kz/'">
                    </div>
                    <!-- <div class="genplan-tab genplan-taunhouse" :class="{ 'is-active': !genplanScheme_init, 'is-leaving': genplanScheme_init && !wasFirst }">
                        <img :src="genplanArr.genplan_img_taunhouse" alt="">
                    </div> -->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import { mapGetters } from 'vuex'

    export default {
        name: 'genplan-section',
        data() {
            return {
                genplanScheme_init: true,
                wasFirst: true, // чтобы не запускать leaving-анимацию при первом рендере
                globalLang: window.GlobalLang,
                wrapperHeight: null,
                animating: false,
            }
        },
        computed: mapGetters({
            genplanArr: 'loadGenplanArr',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
        },
        methods: {
            switchTab(value) {
                if (this.animating || this.genplanScheme_init === value) return;

                this.animating = true;
                const wrapper = this.$refs.wrapper;

                // фиксируем текущую высоту чтобы плавно анимировать
                const fromHeight = wrapper.scrollHeight;
                wrapper.style.height = fromHeight + 'px';

                this.wasFirst = this.genplanScheme_init;
                this.genplanScheme_init = value;

                this.$nextTick(() => {
                    // после смены — узнаём новую высоту через requestAnimationFrame
                    requestAnimationFrame(() => {
                        const toHeight = wrapper.scrollHeight;
                        wrapper.style.height = toHeight + 'px';

                        // по окончании transition — снимаем фиксированную высоту
                        const onEnd = () => {
                            wrapper.style.height = '';
                            this.animating = false;
                            wrapper.removeEventListener('transitionend', onEnd);
                        };
                        wrapper.addEventListener('transitionend', onEnd);
                    });
                });
            }
        },
        mounted() {}
    }
</script>

<style lang="scss">
    @import '@/styles/components/genplan/genplan-section.scss';
    @import '@/styles/components/genplan/respond/genplan-section-respond.scss';
</style>